// Mobile menu nav tabs
const parentLinks = document.querySelectorAll(".sidebar-nav .parent-nav a");

parentLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();

    parentLinks.forEach((link) => {
      link.classList.remove("active");
    });

    e.currentTarget.classList.add("active");

    // Get the index of clicked link
    const index = [
      ...e.currentTarget.parentElement.parentElement.children,
    ].indexOf(e.currentTarget.parentElement);

    const submenus = document.querySelectorAll(".sidebar-nav .sub-menu");

    submenus.forEach((menu, i) => {
      menu.classList.remove("active");
      if (i === index) {
        menu.classList.add("active");
      }
    });
  });
});

// Dropdown menu toggle - on click for accessibility
const parentToggles = document.querySelectorAll(".Header__MainNav .parent button");
const dropdowns = document.querySelectorAll(".Header__MainNav .dropdown");

parentToggles.forEach((toggle) => {
  toggle.addEventListener("click", (e) => {
    e.preventDefault();

    // Close any open dropdowns and toggle clicked one
    dropdowns.forEach((dropdown) => {
      const currentToggle = dropdown.previousElementSibling.querySelector('button');
      if (dropdown !== e.currentTarget.parentElement.nextElementSibling) {
        dropdown.classList.remove("active");
        currentToggle.setAttribute("aria-expanded", "false");
      } else {
        dropdown.classList.toggle("active");
        // Toggle aria-expanded state
        const isExpanded = dropdown.classList.contains("active");
        currentToggle.setAttribute("aria-expanded", isExpanded);
      }
    });
  });
});

// Add dimmed class to bundle select items if the selected variant is out of stock
const updateBundleSelectOosState = () => {
  const bundleSelect = document.querySelector(".bundle-select");

  if (!bundleSelect || !window.__sunflow || !window.__sunflow.product) {
    return;
  }

  const productVariants = window.__sunflow.product.variants;

  if (!Array.isArray(productVariants)) {
    return;
  }

  const selectedColor = document.querySelector(".ColorSwatch__Radio:checked");
  const bundleInputs = bundleSelect.querySelectorAll('input[type="radio"]');

  if (!selectedColor) {
    bundleSelect.querySelectorAll(".item").forEach((item) => {
      item.classList.remove("dimmed");
    });
    return;
  }

  bundleInputs.forEach((input) => {
    const item = input.closest(".item");

    if (!item) {
      return;
    }

    const matchingVariant = productVariants.find(
      (variant) =>
        variant.option1 === selectedColor.value && variant.option2 === input.value
    );

    // Hide quantity discount pill on specific variants 
    item.querySelector('.pill').classList.toggle('hide', matchingVariant.id === 54275115548947 || matchingVariant.id === 54275115450643)

    item.classList.toggle(
      "dimmed",
      Boolean(matchingVariant) && !matchingVariant.available
    );
  });
};

// Update discount box prices when bundle selected
document.querySelectorAll(".bundle-select input").forEach((button) => {
  button.addEventListener("change", (e) => {
    if (
      e.currentTarget.checked &&
      e.currentTarget.hasAttribute("data-bundle")
    ) {
      const isBundle = e.currentTarget.getAttribute("data-bundle");

      // Hide discount box if bundle is selected
      if(document.querySelector(".discount-item")) {
        if(isBundle == "true") {
          document.querySelector(".discount-item").classList.add("hide");
        } else {
          document.querySelector(".discount-item").classList.remove("hide");
        }
      }

      // Update discount amounts
      // if (isBundle == "true") {
      //   document
      //     .querySelectorAll(".discount-item .standard")
      //     .forEach((item) => {
      //       item.classList.remove("active");
      //     });

      //   document
      //     .querySelectorAll(".discount-item .bundle")
      //     .forEach((item) => {
      //       item.classList.add("active");
      //     });
      // } else {
      //   document
      //     .querySelectorAll(".discount-item .bundle")
      //     .forEach((item) => {
      //       item.classList.remove("active");
      //     });

      //   document
      //     .querySelectorAll(".discount-item .standard")
      //     .forEach((item) => {
      //       item.classList.add("active");
      //     });
      // }
    }
  });
});


// Update prices when color swatch is selected
document.addEventListener("change", function (event) {
  if (event.target.matches(".ColorSwatch__Radio")) {

    const selectedColor = event.target.value;

    const productVariants = window.__sunflow.product.variants;

    const colorVariants = productVariants.filter(
      (variant) => variant.option1 === selectedColor
    );

    colorVariants.forEach((variant) => {
      const itemElement = document.querySelector(
        `.bundle-select input[value="${variant.option2}"]`
      );

      if (itemElement) {
        const priceElement = itemElement
          .closest(".item")
          .querySelector("[data-standard-price], [data-bundle-price], [data-bundle-2-price]");
        const comparePriceElement = itemElement
          .closest(".item")
          .querySelector(
            "[data-standard-compare-price], [data-bundle-compare-price], [data-bundle-2-compare-price]"
          );

        const formatPrice = (price) => {
          return price % 100 === 0
            ? `$${(price / 100).toFixed(0)}`
            : `$${(price / 100).toFixed(2)}`;
        };

        // Update the price elements
        if (priceElement) {
          priceElement.textContent = formatPrice(variant.price);
        }

        // Update the compare price element if compare_at_price > price
        if (
          comparePriceElement &&
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {

          comparePriceElement.textContent = formatPrice(
            variant.compare_at_price
          );
        } else if (comparePriceElement) {
          comparePriceElement.textContent = ""; // Clear the compare price if none is set or if it's not greater than the price
        }
      }
    });

    // Fetch the discount item from the selected variant to cover any price changes
    fetch(window.location.href + '?section_id=product-template')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }

        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const discountItem = doc.querySelector('.discount-item');
        document.querySelector('.discount-item').innerHTML = discountItem.innerHTML;
      });
  }
});

// Toggle visiblity of any 'pre-order-text' elements when variant changes
document.addEventListener("variant:changed", (e) => {
  const variant = e.detail.variant;
  const preOrder = window.__sunflow.product.variantMetafields[variant.id];
  const preOrderText = document.querySelectorAll('.pre-order-text');
  if(preOrder) {
    preOrderText.forEach( el => {
      el.classList.remove('hide-element');
    });
  } else {
    preOrderText.forEach( el => {
      el.classList.add('hide-element');
    });
  }

  updateBundleSelectOosState();

});

updateBundleSelectOosState();

// FAQ toggles
document.querySelectorAll('.Faq__Question').forEach( question => {
  question.addEventListener('click', (e)=> {
    e.currentTarget.closest('.Faq__Item').classList.toggle('open');
    toggle(e.currentTarget.nextElementSibling);
  });
});

// FAQ section links
document.querySelectorAll('a.FaqSummary__Link').forEach( link => {
  link.addEventListener('click', (e)=> {
    document.querySelectorAll('.FaqSummary__Item').forEach( item => {
      item.classList.remove('is-active');
    });
    e.currentTarget.parentNode.classList.add('is-active');
  });
});

// Show an element
var show = function(elem) {

  // Get the natural height of the element
  var getHeight = function () {
    elem.style.display = 'block'; // Make it visible
    var height = elem.scrollHeight + 'px'; // Get it's height
    elem.style.display = ''; //  Hide it again
    return height;
  };

  var height = getHeight(); // Get the natural height
  elem.classList.add('is-visible'); // Make the element visible
  elem.style.height = height; // Update the max-height

  // Once the transition is complete, remove the inline max-height so the content can scale responsively
  window.setTimeout(function () {
    elem.style.height = '';
  }, 350);

};

// Hide an element
var hide = function(elem) {

  // Give the element a height to change from
  elem.style.height = elem.scrollHeight + 'px';

  // Set the height back to 0
  window.setTimeout(function () {
    elem.style.height = '0';
  }, 1);

  // When the transition is complete, hide it
  window.setTimeout(function () {
    elem.classList.remove('is-visible');
  }, 350);

};

// Toggle element visibility
var toggle = function(elem, timing) {

  // Hide any open items
  document.querySelectorAll('.Faq__AnswerWrapper').forEach( answer => {
    if (answer.classList.contains('is-visible')) {
      answer.closest('.Faq__Item').classList.remove('open');
      hide(answer);
    }
  });

  // If the element is visible, hide it
  if (elem.classList.contains('is-visible')) {
    hide(elem);
    return;
  }

  // Otherwise, show it
  show(elem);

};

// Toggle sticky CTA visibility once the main add-to-cart button is scrolled past
const stickyCta = document.querySelector(".sticky-cta");

if (stickyCta) {
  const updateStickyCtaVisibility = () => {
    const addToCartButton = document.querySelector(".ProductForm__AddToCart");

    const buttonRect = addToCartButton.getBoundingClientRect();
    const hasScrolledPastAddToCart = buttonRect.bottom <= 0;

    if (hasScrolledPastAddToCart) {
      stickyCta.classList.remove("hidden");
    } else {
      stickyCta.classList.add("hidden");
    }
  };

  // Throttle scroll/resize events with requestAnimationFrame for better performance
  let isTicking = false;
  const onScrollOrResize = () => {
    if (isTicking) {
      return;
    }

    isTicking = true;
    window.requestAnimationFrame(() => {
      updateStickyCtaVisibility();
      isTicking = false;
    });
  };

  window.addEventListener("scroll", onScrollOrResize, { passive: true });
  window.addEventListener("resize", onScrollOrResize);
  window.addEventListener("load", updateStickyCtaVisibility);

  updateStickyCtaVisibility();
}
